import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConstantService {
  constructor() {}

  public static exceptionPair = [
    {
      criteria: 'Demand Aggregation',
      value: ['Daily', 'Weekly', 'Monthly'],
    },
    {
      criteria: 'Demand Horizon',
      value: ['3', '6', '9'],
    },
    {
      criteria: 'Gross Vs Net Demand',
      value: ['Gross', 'Net'],
    },
    {
      criteria: 'Weekly Aggregation - Start Day of Week',
      value: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],
    },
    {
      criteria: 'Material Exclusion',
      value: [''],
    },
  ];
}
